/* eslint-disable no-nested-ternary */
import React from 'react';
import { Controller } from 'react-hook-form';
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Checkbox,
  FormControl,
} from '@material-ui/core';
import useAgentSettingsEffects from './hooks';
import TextTooltip from '../../components/TextTooltip';
import { Select } from '../../components';
import './settings.css';

const AgentSettings = () => {
  const {
    classes,
    configOptions,
    currentConfig,
    settings,
    control,
    errors,
    onSubmit,
    onConfigChange,
  } = useAgentSettingsEffects();
  return (
    <form onSubmit={onSubmit}>
      <Grid container>
        <Grid item container justifyContent="center">
          <Select
            options={configOptions}
            currentOptionIndex={currentConfig}
            onSelect={onConfigChange}
            label="Config"
            className={classes.select}
          />
        </Grid>
        <Grid item container justifyContent="center">
          <Grid
            item
            style={{
              flexGrow: 1,
              minWidth: '80%',
              maxWidth: '1000px',
            }}
          >
            <Paper className={classes.paper}>
              <TableContainer className={classes.tableContainer}>
                <Table
                  style={{ tableLayout: 'fixed' }}
                  stickyHeader
                  aria-label="sticky table"
                >
                  <TableBody>
                    {settings.map(({ env, defaultValue, inputType }) => {
                      return (
                        <TableRow hover tabIndex={-1} key={env}>
                          <TableCell
                            style={{
                              overflow: 'hidden',
                            }}
                            className={`${classes.bold} settings-table-key`}
                          >
                            <TextTooltip text={env} />
                          </TableCell>
                          <TableCell align="left">
                            {inputType === 'array' ? (
                              <FormControl fullWidth>
                                <Controller
                                  name={env}
                                  defaultValue={JSON.stringify(defaultValue)}
                                  render={({ onChange, value }) => (
                                    <TextField
                                      type={inputType}
                                      variant="outlined"
                                      error={errors[env]}
                                      value={JSON.stringify(value) ?? ''}
                                      onChange={({ target }) => {
                                        const newValue = JSON.parse(
                                          target.value
                                        );
                                        onChange(newValue);
                                      }}
                                    />
                                  )}
                                  control={control}
                                />
                              </FormControl>
                            ) : inputType === 'checkbox' ? (
                              <FormControl>
                                <Controller
                                  name={env}
                                  control={control}
                                  defaultValue={defaultValue}
                                  render={({ onChange, value }) => (
                                    <Checkbox
                                      onChange={(e) => {
                                        onChange(e.target.checked);
                                      }}
                                      color="primary"
                                      checked={value}
                                    />
                                  )}
                                />
                              </FormControl>
                            ) : (
                              <FormControl fullWidth>
                                <Controller
                                  name={env}
                                  defaultValue={defaultValue}
                                  render={({ onChange, value }) => (
                                    <TextField
                                      type={inputType}
                                      variant="outlined"
                                      error={errors[env]}
                                      value={value ?? ''}
                                      onChange={({ target }) => {
                                        const newValue =
                                          // eslint-disable-next-line no-nested-ternary
                                          inputType === 'number'
                                            ? target.value === ''
                                              ? null
                                              : +target.value
                                            : target.value;
                                        onChange(newValue);
                                      }}
                                    />
                                  )}
                                  control={control}
                                />
                              </FormControl>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
        <Grid item container justifyContent="center">
          <Button
            size="large"
            className={classes.blueButton}
            variant="contained"
            disableElevation
            type="submit"
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default AgentSettings;
